import { cn } from '@/lib/cn';

interface Props {
  /** Shape the skeleton like the content it replaces — never a centred spinner (DESIGN.md §8). */
  className?: string;
}

/**
 * The loading state's building block: `paper-sunken`, shaped by the caller, pulsing gently.
 * Skeleton shimmer is one of only two motions that carry information (§3 Motion).
 */
export function Skeleton({ className }: Props) {
  return <div aria-hidden className={cn('animate-pulse rounded bg-paper-sunken', className)} />;
}
